import { useFetchRootCategories } from '../../lib/fetches.ts';
import Skeleton from '../Skeleton.tsx';
import CategoryCard from '../cards/CategoryCard.tsx';

export function CategoriesNav() {
    const { data: categories, isLoading } = useFetchRootCategories();

    return (
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {isLoading && (
                <Skeleton count={4} className="h-60 w-full rounded-3xl" />
            )}

            {categories?.map(
                ({ name, description, slug, color, is_locked, icon }) => (
                    <CategoryCard
                        key={slug}
                        href={`/cviceni/${slug}`}
                        color={color}
                        icon={icon}
                        isLocked={is_locked}
                        heading={name}
                        subheading={description}
                    />
                )
            )}
        </div>
    );
}
